<div class="filters-container">
    <div class="body d-flex gap-4">
        <ul class="sidemenu">
            <li (click)="selectActiveItem(item.type)" [class.active]="activeItem == item.type" *ngFor="let item of sidemenuItems">
                {{ item.label }}
            </li>
        </ul>
        <div class="content">
            <div *ngIf="activeItem === 0" class="filter-section">
                <lib-region-filter
                    [regions]="regions"
                    [allAreas]="allAreas"
                    [(selectedAreas)]="selectedAreas"
                ></lib-region-filter>
            </div>
            <div *ngIf="activeItem === 1" class="filter-section">
                <div class="template-filter">
                    <div class="search-box">
                        <div class="search-input-wrapper">
                            <img height="16" width="16" src="assets/icons/search.svg" alt="Search icon" class="search-icon">
                            <input 
                                type="text" 
                                placeholder="Search Substation Types" 
                                [(ngModel)]="templateSearchText"
                                (input)="filteredTemplates"
                            />
                        </div>
                    </div>
                    <div class="templates-list">
                        <label 
                            *ngFor="let template of filteredTemplates" 
                            class="template-item"
                        >
                            <input 
                                type="checkbox" 
                                [checked]="isTemplateSelected({id: template.id!, name: template.className})"
                                (change)="onTemplateSelect({id: template.id!, name: template.className}, $event)"
                            />
                            <span class="checkmark"></span>
                            <span class="template-name">{{ template.className }}</span>
                        </label>
                    </div>
                </div>
            </div>
            <div *ngIf="activeItem === 2" class="filter-section">
                <div class="template-filter">
                    <div class="search-box">
                        <div class="search-input-wrapper">
                            <img height="16" width="16" src="assets/icons/search.svg" alt="Search icon" class="search-icon">
                            <input 
                                type="text" 
                                placeholder="Search Base Voltages" 
                                [(ngModel)]="baseVoltageSearchText"
                                (input)="filteredBaseVoltages"
                            />
                        </div>
                    </div>
                    <div class="templates-list">
                        <label 
                            *ngFor="let bv of filteredBaseVoltages" 
                            class="template-item"
                        >
                            <input 
                                type="checkbox" 
                                [checked]="isBaseVoltageSelected({id: bv.id!, name: bv.name || ''})"
                                (change)="onBaseVoltageSelect({id: bv.id!, name: bv.name || ''}, $event)"
                            />
                            <span class="checkmark"></span>
                            <span class="template-name">{{ bv.name }}</span>
                        </label>
                    </div>
                </div>
            </div>
            <div *ngIf="activeItem === 3" class="filter-section">
                <div class="template-filter">
                    <div class="search-box">
                        <div class="search-input-wrapper">
                            <img height="16" width="16" src="assets/icons/search.svg" alt="Search icon" class="search-icon">
                            <input 
                                type="text" 
                                placeholder="Search Ratings" 
                                [(ngModel)]="ratingSearchText"
                                (input)="filteredRatings"
                            />
                        </div>
                    </div>
                    <div class="templates-list">
                        <label 
                            *ngFor="let rating of filteredRatings" 
                            class="template-item"
                        >
                            <input 
                                type="checkbox" 
                                [checked]="isRatingSelected({id: rating.id!, name: rating.kvaRating || ''})"
                                (change)="onRatingSelect({id: rating.id!, name: rating.kvaRating || ''}, $event)"
                            />
                            <span class="checkmark"></span>
                            <span class="template-name">{{ rating.kvaRating }}</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="selectedAreas.length > 0 || selectedTemplates.length > 0 || selectedRatings.length > 0 || selectedBaseVoltages.length > 0" class="selected-areas-container">
        <div class="selected-area-pill" *ngFor="let area of selectedAreas">
            <svg 
                width="12" 
                height="12" 
                viewBox="0 0 12 12" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                (click)="removeArea(area)"
                class="remove-icon"
            >
                <path 
                    d="M9 3L3 9M3 3L9 9" 
                    stroke="currentColor" 
                    stroke-width="1.5" 
                    stroke-linecap="round" 
                    stroke-linejoin="round"
                />
            </svg>
            <span>{{ area.name }}</span>
        </div>
        <div class="selected-area-pill" *ngFor="let template of selectedTemplates">
            <svg 
                width="12" 
                height="12" 
                viewBox="0 0 12 12" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                (click)="removeTemplate(template)"
                class="remove-icon"
            >
                <path 
                    d="M9 3L3 9M3 3L9 9" 
                    stroke="currentColor" 
                    stroke-width="1.5" 
                    stroke-linecap="round" 
                    stroke-linejoin="round"
                />
            </svg>
            <span>{{ template.name }}</span>
        </div>
        <div class="selected-area-pill" *ngFor="let bv of selectedBaseVoltages">
            <svg 
                width="12" 
                height="12" 
                viewBox="0 0 12 12" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                (click)="removeBaseVoltage(bv)"
                class="remove-icon"
            >
                <path 
                    d="M9 3L3 9M3 3L9 9" 
                    stroke="currentColor" 
                    stroke-width="1.5" 
                    stroke-linecap="round" 
                    stroke-linejoin="round"
                />
            </svg>
            <span>{{ bv.name }}</span>
        </div>
        <div class="selected-area-pill" *ngFor="let rating of selectedRatings">
            <svg 
                width="12" 
                height="12" 
                viewBox="0 0 12 12" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                (click)="removeRating(rating)"
                class="remove-icon"
            >
                <path 
                    d="M9 3L3 9M3 3L9 9" 
                    stroke="currentColor" 
                    stroke-width="1.5" 
                    stroke-linecap="round" 
                    stroke-linejoin="round"
                />
            </svg>
            <span>{{ rating.name }}</span>
        </div>
    </div>
    <div class="footer">
        <button class="button-clear" (click)="onClearFilter()">Clear Filter</button>
        <button class="button-apply" (click)="onApplyFilter()">Apply Filter</button>
    </div>
</div>